import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";

export default function Spinner({ minLoadingTime = 5000 }) {
    const [showSpinner, setShowSpinner] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowSpinner(false);
        }, minLoadingTime);

        return () => clearTimeout(timer);
    }, [minLoadingTime]);

    if (!showSpinner) {
        return null;
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100%",
                position: "fixed",
                top: 0,
                left: 0,
                backgroundColor: "rgba(255, 255, 255, 0.95)",
                zIndex: 9999,
                backdropFilter: "blur(2px)",
                gap: 2
            }}
        >
            <Box
                component="img"
                src="/spinner.gif"
                alt="loading"
                sx={{
                    width: { xs: 60, sm: 80 },
                    height: "auto",
                    objectFit: "contain"
                }}
            />
            <Typography
                variant="h6"
                component="div"
                sx={{
                    color: "primary.main",
                    fontWeight: 500,
                    letterSpacing: 1,
                    mt: 1
                }}
            >
                Loading...
            </Typography>
        </Box>
    );
}